import React from 'react';

import { Link } from 'src/containers/Link';

import { Button } from 'src/components/atoms/Button';

export default { Button, a: ({ href, ...rest }) => <Link to={href} {...rest} /> };
